<section [formGroup]="employment_info" fxLayout="column" fxLayoutGap="8px">

  <mat-form-field>
    <bb-agency-field formControlName="manning_agency"
                     (setAgencyPk)="employment_info.get('agency').setValue($event)"
                     placeholder="Manning Agency" required></bb-agency-field>
    <mat-error *ngIf="employment_info.get('manning_agency').hasError('required')">Required.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input matInput placeholder="Principal" formControlName="seaman_principal">
  </mat-form-field>

</section>
